import { ToastProvider, useToasts } from 'react-toast-notifications';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
  Alert,
  ButtonGroup,
  Col,
  Form,
  FormGroup,
  Row,
  Container,
  Accordion,
} from 'react-bootstrap';
import LinearIndeterminate from '../../components/LinearIndeterminate/LinearIndeterminate';

import Card from '../../components/Card/Card';
import language from '../../config/es';
import LabelTitle from '../../components/Label/labelTitle';
import LabelChargeData from '../../components/Label/labelChargeData';
import Select from 'react-select';
import Button from '../../components/CustomButton/CustomButton';
import DataTable from 'react-data-table-component';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';
import { getTemplates, createTemplate } from '../../redux/template.duck';
import {
  getDetail,
  createDetail,
  updateDetailData,
  deleteDetail,
} from '../../redux/templateDetail.duck';
import { es_vacio, es_entero, isGreaterOrEqual } from '../../config/validate';
//Session user
import SessionConfig from '../../config/session_config';

const Template = () => {
  const ref = useRef();
  const { addToast } = useToasts();
  const dispatch = useAppDispatch();
  const [showloadingTemplate, setShowloadingTemplate] = useState(false);
  const [enable, setEnable] = useState(false);
  const [long, setLong] = useState(0);
  const [template, setTemplate] = useState({
    name: { value: '', error: '' },
    selectTemplate: { value: 0, label: '', error: '' },
    list: [],
    errors: [],
    pendingData: false,
    enable: true,
    auth: JSON.parse(sessionStorage.getItem('user')),
    response: '',
    error: '',
  });
  const [detail, setDetail] = useState({
    id: null,
    posInitial: { value: 0, error: '' },
    posEnd: { value: 0, error: '' },
    fieldName: { value: '', error: '' },
    fielValue: { value: '', error: '' },
    description: { value: '', error: '' },
    formatDate: { value: '', error: '' },
    decimalSeparator: { value: '', error: '' },
    decimalcount: { value: '', error: '' },
    sequence: { value: '', error: '' },
    error: '',
    errors: [],
    list: [],
    columns: [],
    selectedRows: [],
    pendingData: false,
    showDelete: false,
    response: '',
    responseDelete: '',
  });

  template.list = useSelector((store) => store.templateReducer.templates);
  template.error = useSelector((store) => store.templateReducer.errorTemplate);
  detail.error = useSelector((store) => store.detailReducer.errorDetail);
  detail.list = useSelector((store) => store.detailReducer.details);
  detail.response = useSelector((store) => store.detailReducer.createDetail);
  detail.responseDelete = useSelector(
    (store) => store.detailReducer.deleteDetail
  );

  template.response = useSelector(
    (store) => store.templateReducer.createTemplate
  );

  //#region useEffect
  useEffect(() => {
    void responseDelete();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detail.responseDelete]);
  useEffect(() => {
    void loadDetail();
    void responseAction();
    setEnable(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detail.response]);

  useEffect(() => {
    messageError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [template.error, detail.error]);

  useEffect(() => {
    void loadTemplates();
    initTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    ref.current.onRefreshCurrentSession();
  }, [template, detail]);
  useEffect(() => {
    if (template.selectTemplate.value > 0) {
      void loadDetail();
    }
    setEnable(template.selectTemplate.value > 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [template.selectTemplate]);
  useEffect(() => {
    if (!es_vacio(template.response)) {
      viewNotification(
        language.messages.msmRegister.replace('{0}', template.name.value),
        'success'
      );

      void loadTemplates();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [template.response]);
  //#endregion
  //#region function

  const responseDelete = async () => {
    if (!es_vacio(detail.responseDelete)) {
      viewNotification(language.messages.msmDisableAll, 'success');
      void loadDetail();
      setEnable(true);
    }
  };

  const messageError = () => {
    if (template.error !== '') {
      viewNotification(template.error.error, 'error');
    }
    if (detail.error !== '') {
      viewNotification(detail.error.error, 'error');
    }
  };

  const viewNotification = (msm, action) => {
    addToast(msm, {
      appearance: action,
      autoDismiss: true,
    });
  };
  const loadTemplates = async () => {
    setShowloadingTemplate(false);
    await dispatch(getTemplates());
    setShowloadingTemplate(true);
  };
  const refreshTemplateData = () => {
    setTemplate({
      ...template,
    });
  };
  const refreshDetailData = () => {
    setDetail({
      ...detail,
    });
  };
  const updateDetailState = (value, id) => {
    setDetail({
      ...detail,
      [id]: value,
    });
  };

  const updateTemplateState = (value, id) => {
    setTemplate({
      ...template,
      [id]: value,
    });
  };
  const onChange = async (event) => {
    switch (event.target.name) {
      case 'name':
        template.name.value = event.target.value;
        template.name.error = '';
        refreshTemplateData();
        break;
      case 'posEnd':
        detail.posEnd.value = event.target.value;
        detail.posEnd.error = '';
        updateDetailState(detail.posEnd, 'posEnd');
        getLength();

        break;
      case 'posInitial':
        detail.posInitial.value = event.target.value;
        detail.posInitial.error = '';
        updateDetailState(detail.posInitial, 'posInitial');
        getLength();

        break;
      default:
        updateDetailState(
          { value: event.target.value, error: '' },
          event.target.name
        );

        break;
    }
  };
  const getLength = () => {
    if (es_entero(detail.posEnd.value) && es_entero(detail.posInitial.value)) {
      let length =
        Number.parseInt(detail.posEnd.value) -
        Number.parseInt(detail.posInitial.value) +
        1;
      setLong(Math.max(length, 0));
    } else {
      setLong(0);
    }
  };
  const loadDetail = async () => {
    detail.pendingData = true;
    updateDetailState(true, 'pendingData');
    await dispatch(
      getDetail(template.selectTemplate.value, template.auth.id.user.username)
    );
    detail.pendingData = false;
    refreshDetailData();
  };
  const responseAction = async () => {
    if (!es_vacio(detail.response)) {
      viewNotification(
        language.messages.msmRegister.replace('{0}', detail.response.fieldName),
        'success'
      );
    }
  };
  const cleanDetail = () => {
    clearErrorDetail();
    clearForm();
    refreshDetailData();
  };
  const clearErrorTemplate = () => {
    template.errors = [];
    template.name.error = '';
  };
  const clearFormTemplate = () => {
    template.name = { value: '', error: '' };
    refreshTemplateData();
  };
  const clearForm = () => {
    detail.id = null;
    detail.posInitial.value = 0;
    detail.posEnd.value = 0;
    setLong(0);
    detail.fieldName.value = '';
    detail.fielValue.value = '';
    detail.description.value = '';
    detail.formatDate.value = '';
    detail.decimalSeparator.value = '';
    detail.decimalcount.value = '';
    detail.sequence.value = '';
  };
  const clearErrorDetail = () => {
    detail.errors = [];
    detail.posInitial.error = '';
    detail.posEnd.error = '';
    detail.fieldName.error = '';
    detail.fielValue.error = '';
    detail.description.error = '';
    detail.sequence.error = '';
  };
  const validateDetail = () => {
    clearErrorDetail();
    if (!es_entero(detail.posInitial.value)) {
      detail.errors.push('posInitial.error');
      detail.posInitial.error = language.messages.warningOnlyNumericSmall;
    }
    if (!es_entero(detail.posEnd.value)) {
      detail.errors.push('posEnd.error');
      detail.posEnd.error = language.messages.warningOnlyNumericSmall;
    }
    if (es_entero(detail.posEnd.value) && es_entero(detail.posInitial.value)) {
      if (!isGreaterOrEqual(detail.posEnd.value, detail.posInitial.value)) {
        detail.errors.push('posEnd.error');
        detail.posEnd.error = language.messages.template.errorPositionEnd;
      }
    }
    if (es_vacio(detail.fieldName.value)) {
      detail.errors.push('fieldName.error');
      detail.fieldName.error = language.messages.warning_required_field_small;
    }

    if (es_vacio(detail.description.value)) {
      detail.errors.push('description.error');
      detail.description.error = language.messages.warning_required_field;
    }
    if (!es_entero(detail.sequence.value)) {
      detail.errors.push('sequence.error');
      detail.sequence.error = language.messages.warningOnlyNumericSmall;
    }

    if (
      !es_entero(detail.decimalcount.value) &&
      !es_vacio(detail.decimalcount.value)
    ) {
      detail.errors.push('decimalcount.error');
      detail.decimalcount.error = language.messages.warningOnlyNumericSmall;
    }
  };
  const validateTemplate = () => {
    clearErrorTemplate();
    if (es_vacio(template.name.value)) {
      template.errors.push('name.error');
      template.name.error = language.messages.warning_required_field;
    }
  };
  const saveTemplate = async () => {
    validateTemplate();
    if (template.errors.length === 0) {
      setShowloadingTemplate(false);
      updateTemplateState(false, 'enable');
      let json = {
        name: template.name.value,
        username: template.auth.id.user.username,
      };
      await dispatch(createTemplate(json, template.auth.id.user.username));
      updateTemplateState(true, 'enable');
      clearFormTemplate();
    } else {
      viewNotification(language.messages.msmErrorForm, 'error');
    }
  };
  const saveDetail = async () => {
    validateDetail();
    if (detail.errors.length === 0) {
      detail.pendingData = true;
      setEnable(false);
      let json = {
        id: detail.id,
        template: { id: template.selectTemplate.value },
        endPosition: detail.posEnd.value,
        startPosition: detail.posInitial.value,
        description: detail.description.value,
        fieldValue: detail.fielValue.value,
        length: long,
        sequence: detail.sequence.value,
        fieldName: detail.fieldName.value,
        status: 1,
        format: detail.formatDate.value,
        decimalSeparator: detail.decimalSeparator.value,
        decimalCount: detail.decimalcount.value,
      };
      if (detail.id === null) {
        await dispatch(createDetail(json, template.auth.id.user.username));
      } else {
        await dispatch(updateDetailData(json, template.auth.id.user.username));
      }
      cleanDetail();
    } else {
      viewNotification(language.messages.msmErrorForm, 'error');
    }
  };
  const updateSelect = async (value, id) => {
    template.selectTemplate = value;
    detail.pendingData = true;
    refreshTemplateData();
  };
  const handleSelectRow = (state) => {
    updateDetailState(state.selectedRows, 'selectedRows');
  };
  const handleDelete = () => {
    void disableData();
  };
  const disableData = async () => {
    if (detail.selectedRows.length > 0) {
      setEnable(false);
      detail.showDelete = false;
      detail.pendingData = true;
      await dispatch(
        deleteDetail(detail.selectedRows, template.auth.id.user.username)
      );
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const contextActions = React.useMemo(() => {
    return (
      <Button
        key="delete"
        onClick={handleDelete}
        className="btn btn-danger-up"
        type="button"
        disabled={!enable}
      >
        {' '}
        <i className="fa fa-trash"></i>
        {language.messages.btnDisable}
      </Button>
    );
  });

  const initTable = () => {
    detail.columns = [
      {
        name: '',
        cell: (row) => (
          <button
            className="btn-fill btn btn-xs  btn-primary"
            type="button"
            onClick={() => {
              handleButtonEdit(row);
            }}
            id={row.Id}
          >
            <i className="fa fa-pencil"></i>
          </button>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        width: '40px',
      },
      {
        name: language.messages.template.lblsequence,
        sortable: false,
        wrap: true,
        width: '70px',
        right: true,
        cell: (row) => <div className="text-info  ">{row.sequence}</div>,
      },
      {
        name: language.messages.template.lblposInit,
        sortable: false,
        wrap: true,
        width: '70px',
        right: true,
        cell: (row) => <div className="text-dark  ">{row.startPosition}</div>,
      },

      {
        name: language.messages.template.lblposEnd,
        sortable: false,
        wrap: true,
        width: '70px',
        right: true,
        cell: (row) => <div className="text-dark  ">{row.endPosition}</div>,
      },

      {
        name: language.messages.template.name,
        sortable: false,
        wrap: true,
        width: '200px',
        cell: (row) => <div className="text-dark">{row.fieldName}</div>,
      },
      {
        name: language.messages.template.lbllentgh,
        sortable: false,
        wrap: true,
        width: '70px',
        right: true,
        cell: (row) => <div className="text-muted  ">{row.length}</div>,
      },
      {
        name: language.messages.template.lblField,
        sortable: false,
        wrap: true,
        width: '200px',
        cell: (row) => <div className="text-primary">{row.fieldValue}</div>,
      },
    ];
  };
  const handleButtonEdit = (row) => {
    detail.id = row.id;
    detail.posInitial.value = row.startPosition;
    detail.posEnd.value = row.endPosition;
    detail.fieldName.value = row.fieldName;
    detail.fielValue.value = row.fieldValue;
    detail.description.value = row.description;
    detail.formatDate.value = row.format;
    detail.decimalSeparator.value = row.decimalSeparator;
    detail.decimalcount.value = row.decimalCount;
    detail.sequence.value = row.sequence;
    getLength();
    refreshDetailData();
  };
  //#endregion
  return (
    <Fragment>
      <SessionConfig ref={ref} />
      <br />
      <Container fluid={true}>
        <Row>
          <Col md={5} xl={4}>
            <Accordion defaultActiveKey="1">
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  {language.messages.template.title}{' '}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    <Col md={10}>
                      <FormGroup>
                        <LabelTitle
                          text={language.messages.template.name}
                          requerid={true}
                        />
                        <Form.Control
                          autoComplete="namee"
                          size="sm"
                          type="text"
                          name="name"
                          id="name"
                          value={template.name.value}
                          onChange={onChange}
                        />
                        <span className="small text-danger">
                          {template.name.error}
                        </span>
                      </FormGroup>
                    </Col>
                    <Col>
                      <LabelTitle
                        text={<span>&nbsp;&nbsp;</span>}
                        requerid={false}
                      />
                      <Button
                        disabled={!template.enable}
                        fill
                        font_small
                        type="button"
                        onClick={saveTemplate}
                      >
                        <i className="fa fa-save"></i>{' '}
                      </Button>
                    </Col>
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>{language.messages.template.detail}</Accordion.Header>
                <Accordion.Body>
                <form autoComplete="off" name="detail">
                  <Alert className="alert-primary">
                    <strong className="text-danger small">
                      {language.messages.labelSymbol}
                    </strong>
                    <span className="small">
                      {' '}
                      {language.messages.labelSymbolRequired}
                    </span>
                  </Alert>
                  <Row>
                    <Col md={12}>
                      <LabelTitle
                        text={language.messages.template.lblTemplate}
                        requerid={true}
                      />
                    </Col>

                    <LabelChargeData showloading={showloadingTemplate} />
                  </Row>
                  <FormGroup>
                    <Select classNamePrefix="ui-select"
                      isDisabled={detail.id !== null}
                      placeholder={language.messages.lblSingleSelect}
                      name="template"
                      options={template.list}
                      className="text-uppercase small"
                      value={{
                        value: template.selectTemplate.value,
                        label: template.selectTemplate.label,
                      }}
                      onChange={(value) => {
                        void updateSelect(value);
                      }}
                    />
                    <span className="small text-danger">
                      {template.selectTemplate.error}
                    </span>
                  </FormGroup>
                  <Row>
                    <Col>
                      <FormGroup>
                        <LabelTitle
                          text={language.messages.template.posInitial}
                          requerid={true}
                        />
                        <Form.Control
                          size="sm"
                          type="text"
                          name="posInitial"
                          id="posInitial"
                          value={detail.posInitial.value}
                          onChange={onChange}
                        />
                        <span className="small text-danger">
                          {detail.posInitial.error}
                        </span>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <LabelTitle
                          text={language.messages.template.posEnd}
                          requerid={true}
                        />
                        <Form.Control
                          size="sm"
                          type="text"
                          name="posEnd"
                          id="posEnd"
                          value={detail.posEnd.value}
                          onChange={onChange}
                        />
                        <span className="small text-danger">
                          {detail.posEnd.error}
                        </span>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <LabelTitle
                          text={language.messages.template.long}
                          requerid={false}
                        />
                        <Form.Control
                          disabled={true}
                          size="sm"
                          type="text"
                          name="long"
                          id="long"
                          value={long}
                          onChange={onChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup>
                        <LabelTitle
                          text={language.messages.template.field.name}
                          requerid={true}
                        />
                        <Form.Control
                          size="sm"
                          type="text"
                          name="fieldName"
                          id="fieldName"
                          value={detail.fieldName.value}
                          onChange={onChange}
                        />
                        <span className="small text-danger">
                          {detail.fieldName.error}
                        </span>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <LabelTitle
                          text={language.messages.template.field.value}
                          requerid={false}
                        />
                        <Form.Control
                          size="sm"
                          type="text"
                          name="fielValue"
                          id="fielValue"
                          value={detail.fielValue.value}
                          onChange={onChange}
                        />
                        <span className="small text-danger">
                          {detail.fielValue.error}
                        </span>
                      </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup>
                    <LabelTitle
                      text={language.messages.template.description}
                      requerid={true}
                    />
                    <Form.Control
                      as="textarea"
                      size="sm"
                      type="text"
                      name="description"
                      id="description"
                      value={detail.description.value}
                      onChange={onChange}
                    />
                    <span className="small text-danger">
                      {detail.description.error}
                    </span>
                  </FormGroup>
                  <Row className="align-items-end">
                    <Col>
                      <FormGroup>
                        <LabelTitle
                          text={language.messages.template.formatDate}
                          requerid={false}
                        />
                        <Form.Control
                          size="sm"
                          type="text"
                          name="formatDate"
                          id="formatDate"
                          value={detail.formatDate.value}
                          onChange={onChange}
                        />
                        <span className="small text-danger">
                          {detail.formatDate.error}
                        </span>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <LabelTitle
                          text={language.messages.template.sequence}
                          requerid={true}
                        />
                        <Form.Control
                          size="sm"
                          type="text"
                          name="sequence"
                          id="sequence"
                          value={detail.sequence.value}
                          onChange={onChange}
                        />
                        <span className="small text-danger">
                          {detail.sequence.error}
                        </span>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="align-items-end">
                    <Col>
                      <FormGroup>
                        <LabelTitle
                          text={language.messages.template.decimalSeparator}
                          requerid={false}
                        />
                        <Form.Control
                          size="sm"
                          type="text"
                          name="decimalSeparator"
                          id="decimalSeparator"
                          value={detail.decimalSeparator.value}
                          onChange={onChange}
                        />
                        <span className="small text-danger">
                          {detail.decimalSeparator.error}
                        </span>
                      </FormGroup>
                    </Col>
                    <Col className="align-bottom">
                      <FormGroup>
                        <LabelTitle
                          text={language.messages.template.decimalcount}
                          requerid={false}
                        />
                        <Form.Control
                          size="sm"
                          type="text"
                          name="decimalcount"
                          id="decimalcount"
                          value={detail.decimalcount.value}
                          onChange={onChange}
                        />
                        <span className="small text-danger">
                          {detail.decimalcount.error}
                        </span>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <ButtonGroup className="d-flex">
                        <Button
                          disabled={!enable}
                          fill
                          font_small
                          type="button"
                          onClick={saveDetail}
                        >
                          <i className="fa fa-save"></i>{' '}
                          {detail.id === null
                            ? language.messages.btnSave
                            : language.messages.btnEdit}
                        </Button>
                        <Button
                          disabled={!enable}
                          info
                          fill
                          font_small
                          type="button"
                          onClick={cleanDetail}
                        >
                          <i className="fa fa-magnet"></i>{' '}
                          {language.messages.btnClear}
                        </Button>
                        <Button
                          disabled={!enable}
                          warning
                          fill
                          font_small
                          type="button"
                          onClick={loadDetail}
                        >
                          <i className="fa fa-repeat"></i>{' '}
                          {language.messages.btnReload}
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </Row>
                </form>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
             
          </Col>
          <Col md={7} xl={8}>
            <Card
              icono=" fa fa-list"
              title={language.messages.template.registerData}
              content={
                <div className="fresh-datatables">
                  <DataTable
                    noHeader={es_vacio(template.selectTemplate.label)}
                    title={template.selectTemplate.label}
                    data={detail.list}
                    columns={detail.columns}
                    fixedHeader
                    fixedHeaderScrollHeight="600px"
                    selectableRows
                    dense
                    onSelectedRowsChange={handleSelectRow}
                    pointerOnHover={true}
                    highlightOnHover
                    pagination
                    paginationComponentOptions={
                      language.messages.paginationOptions
                    }
                    progressPending={detail.pendingData}
                    progressComponent={<LinearIndeterminate />}
                    contextActions={contextActions}
                    persistTableHead
                    clearSelectedRows={detail.showDelete}
                  />
                </div>
              }
            />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
const App = () => (
  <ToastProvider>
    <Template />
  </ToastProvider>
);
export default App;
